
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CredentialType } from 'enums/CredentialType';
import { Model, ModelProperty } from 'models/Model';


export class CredentialsDtoModel extends Model<CredentialsDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'credentials', type: 'CredentialType[]', languageString: 'credentialsDto.property.credentials', isArray: true },
		{ name: 'customCredentials', type: 'string[]', languageString: 'credentialsDto.property.customCredentials', isArray: true }
	];
	[key: string]: any;
	
	public credentials: CredentialType[];
	public customCredentials: string[];
    
	constructor(){
		super();
		this.credentials = [];
		this.customCredentials = [];
		
	}
	getProperties(){
		return CredentialsDtoModel.classProperties;
	}
}

